
import React, { useEffect } from 'react';

interface AIAssistantProps {
  isOpen: boolean;
  onClose: () => void;
}

const AIAssistant: React.FC<AIAssistantProps> = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return;

    // Implementation of the user-provided script logic
    const handleFrameLoad = () => {
      if (navigator.permissions && navigator.permissions.query) {
        // @ts-ignore - name: 'microphone' is correct but sometimes lacks type defs in older environments
        navigator.permissions.query({ name: 'microphone' })
          .then(result => {
            if (result.state === 'granted') {
              console.log('Microphone access already granted');
            } else if (result.state === 'prompt') {
              console.log('User will be prompted for microphone access');
            }
          })
          .catch(err => console.error('Permission query error:', err));
      }
    };

    const frame = document.getElementById('assistantFrame');
    if (frame) {
      frame.addEventListener('load', handleFrameLoad);
    }

    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      if (frame) {
        frame.removeEventListener('load', handleFrameLoad);
      }
      window.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center px-6">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/80 backdrop-blur-sm animate-fade-in" 
        onClick={onClose}
      ></div>
      
      {/* Modal Container */}
      <div className="relative w-full max-w-lg glass-card rounded-[3rem] border border-white/10 overflow-hidden shadow-[0_30px_100px_rgba(0,0,0,0.8)] animate-slide-up">
        <div className="p-8 border-b border-white/5 flex justify-between items-center bg-black/40">
          <div className="flex items-center space-x-3">
            <div className="w-2 h-2 rounded-full bg-[#1d3fc4] dot-pulse"></div>
            <span className="mono text-[10px] font-bold text-[#1d3fc4] tracking-[0.4em] uppercase">SECURE_VOICE_LINK</span>
          </div>
          <button 
            onClick={onClose}
            className="p-2 text-gray-500 hover:text-white transition-colors"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
        </div>

        <div className="p-10 flex flex-col items-center">
          {/* User provided code integrated here with color updated to deep blue #1d3fc4 */}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
            <iframe 
                src="https://iframes.ai/o/1766294889026x657918132058062800?color=1d3fc4&icon=bot"
                allow="microphone"
                style={{ width: '100%', height: '200px', border: 'none' }}
                id="assistantFrame"
                title="AI Voice Assistant"
            ></iframe>
          </div>

          <div className="mt-8 pt-8 border-t border-white/5 w-full flex justify-center">
             <button 
              onClick={onClose}
              className="px-10 py-4 bg-white/5 border border-white/10 text-white mono text-[10px] font-bold uppercase tracking-widest rounded-xl hover:bg-white hover:text-black transition-all"
            >
              Close Transmission
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIAssistant;
